import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isE3dGrpDropdownEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('e3dGrpDropdown'),
)

export default isE3dGrpDropdownEnabledSelector
